/*
 * @Author: yuehui
 * @Date: 2019-10-28 11:10:21
 * @LastEditTime: 2019-12-03 09:29:27
 * @LastEditors: yuehui
 * @Description:
 */
// import axios from './mock/mock'
import axios from 'axios'
import Qs from 'qs'
// import { getToken } from '@/utils/auth'
import Vue from 'vue'
import { Notify } from 'vant'
Vue.prototype.axios = axios

const service = axios.create({
  timeout: 60000,
  transformRequest: [
    function(data) {
      if (!data) {
        data = {}
      }
      // const jsonText = { ...data }
      // delete jsonText.token
      // const postData = { ...data }
      // postData.jsonText = jsonText ? JSON.stringify(jsonText) : ''
      return Qs.stringify(data)
    }
  ]
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(

  response => {
    if (response.status !== 200) {
      Notify({ type: 'danger', message: '数据异常，请联系管理员' })
      return
    }
    const status = response.data.status
    if (status.succeed.toString() === '1') {
      return response
    }
    treatErrorCode(response)
    return Promise.reject(new Error(+response.data.status.error_code === 401 ? '' : status.error_desc))
  },
  (err) => {
    console.log(err)
    // Sentry.captureException(err, {
    //   level: 'error'
    // })
    return Promise.reject(err)
  }
)

const treatErrorCode = res => {
  if (+res.data.status.error_code === 401) {
    // Notify({ type: 'danger', message: '登陆失效请重新登陆' })
    window.location.reload()
    // window.location.href = res.data.redirect_url
  } else {
    // Sentry.captureException({
    //   ...res,
    //   data: {
    //     ...res.data,
    //     data: JSON.stringify(res.data.data),
    //     status: JSON.stringify(res.data.status)
    //   }
    // }, {
    //   level: 'error'
    // })
  }
}

export default service
